<template>
  <button
    v-on="listeners"
    v-bind="attrs"
    :class="[custom, sizeClasses, modeClasses, isLoading, { disabled: disabled }]"
    :disabled="disabled"
    class="cbutton"
    :aria-label="ariaLabel"
    :type="type"
    :ref="refName"
    >
    <span v-if="text" class="flex items-center">
      <base-icon
        :name="icon" 
        :size="sizeIcon" 
        class="mr-1" 
        v-if="hasIcon && !loading"/>
      <span>{{ text }}</span>
    </span>
    <slot v-else />
  </button>
</template>

<script>
import icons from '@/components/icons/_iconLibrary'
export default {
  name: 'base-button',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button',
    },
    mode: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return [
          'primary', 
          'staticprimary', 
          'secondary', 
          'staticsecondary', 
          'primary-phantom', 
          'staticprimary-phantom', 
          'secondary-phantom', 
          'secondary-phantom-blue', 
          'primary-line', 
          'tools', 
          'core']
          .indexOf(value) !== -1
      }
    },
    icon: {
      type: String,
      default: 'none',
      validator (value) {
        return icons.includes(value)
      }
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['xs', 'sm', 'md', 'xs-button', 'md-button', 'lg'].indexOf(value) !== -1
      }
    },
    sizeIcon: {
      type: String,
      default: 'sm',
    },
    custom: {
      type: [Array, String, Object],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    refName: {
      type: String,
      default: 'baseBtn',
    },
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    hasIcon: function () {
      return this.icon !== 'none'
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        'cbutton--staticprimary': this.mode === 'staticprimary',
        'cbutton--secondary': this.mode === 'secondary',
        'cbutton--staticsecondary': this.mode === 'staticsecondary',
        'cbutton--prim-phantom': this.mode === 'primary-phantom',
        'cbutton--staticprim-phantom': this.mode === 'staticprimary-phantom',
        'cbutton--sec-phantom': this.mode === 'secondary-phantom',
        'cbutton--prim-line': this.mode === 'primary-line',
        'cbutton--tools': this.mode === 'tools',
        'cbutton--core': this.mode === 'core',
        'cbutton--sec-phantom-blue': this.mode === 'secondary-phantom-blue',
      }
    },
    sizeClasses: function () {
      return {
        'h-8 px-4': this.size === 'xs',
        'h-8 pl-2 pr-1': this.size === 'xs-button',
        'h-9 px-4': this.size === 'sm',
        'h-10 px-4 md:px-6': this.size === 'md',
        'h-10 pl-2 pr-1': this.size === 'md-button',
      }
    },
  },
  methods: {
    focus () {
      const refName = this.refName
      this.$refs[refName].focus()
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/BaseButton.scss";
</style>
